import { useEffect } from 'react';
import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';

export const useRenderTinyEffect = () => {
  const { renderTiny, setRenderTiny } = useWYSIWYGContext();

  useEffect(() => {
    // To re-initialize TinyMCE:
    // In order to apply any styles or stylesheets that may exist in the content <head>, and any
    // style or class attributes that may exist on the content <body> (when isFullHtmlDoc === true),
    // we must reinitialize the editor with new values for body_class, content_css, & content_style
    // since there is no way to modify them on an active editor.
    // Whenever the member may have modified these styles (loading an html file or editing the html
    // directly), call onChange & setInitValue with the new editor value, then setRenderTiny(false).
    // This will trigger an unmount and mount of the component refreshing all of the init
    // configuration to the updated values.
    // Note: This process may be skipped when isFullHtmlDoc === false because these portions of the
    // full html doc are not considered (example: snippets)
    if (!renderTiny) {
      setRenderTiny(true);
    }
  }, [renderTiny]);
};
